import { render, staticRenderFns } from "./tobFileList.vue?vue&type=template&id=c922c2ea&scoped=true&"
import script from "./tobFileList.vue?vue&type=script&lang=js&"
export * from "./tobFileList.vue?vue&type=script&lang=js&"
import style0 from "./tobFileList.vue?vue&type=style&index=0&id=c922c2ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c922c2ea",
  null
  
)

export default component.exports